/** Cap optimizer grid selection: allow deselect-all + single toggles; ignore select-all. */
export function clampInsurancePlanGridSelection(prev, next, max) {
  if (next.length === 0) return [];
  const newlySelected = next.filter((id) => !prev.includes(id));
  if (newlySelected.length > 1) return prev;
  return [...prev.filter((id) => next.includes(id)), ...newlySelected].slice(0, max);
}

// ponytail: runnable check — node src/components/Insurance/components/clampInsurancePlanGridSelection.js
if (process.argv?.[1]?.endsWith("clampInsurancePlanGridSelection.js")) {
  const assert = (cond, msg) => {
    if (!cond) throw new Error(msg);
  };
  const eq = (a, b) => assert(JSON.stringify(a) === JSON.stringify(b), `${JSON.stringify(a)} !== ${JSON.stringify(b)}`);
  eq(clampInsurancePlanGridSelection([], [1, 2, 3], 2), []); // select-all ignored
  eq(clampInsurancePlanGridSelection([1], [1, 2, 3], 2), [1]); // select-all with prior pick kept
  eq(clampInsurancePlanGridSelection([1], [1, 2], 2), [1, 2]); // single add
  eq(clampInsurancePlanGridSelection([1, 2], [2], 2), [2]); // single deselect
  eq(clampInsurancePlanGridSelection([1, 2], [], 2), []); // deselect-all
  eq(clampInsurancePlanGridSelection([1, 2], [1, 2], 1), [1]); // cap keeps first
  console.log("clampInsurancePlanGridSelection: ok");
}
